import { render, staticRenderFns } from "./UnidadeMedidaCadastro.vue?vue&type=template&id=5b14cd21&scoped=true&lang=html&"
import script from "./UnidadeMedidaCadastro.vue?vue&type=script&lang=js&"
export * from "./UnidadeMedidaCadastro.vue?vue&type=script&lang=js&"
import style0 from "./UnidadeMedidaCadastro.vue?vue&type=style&index=0&id=5b14cd21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b14cd21",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/unidade-medida/UnidadeMedidaCadastro.vue
// module id = 1601
// module chunks = 28